/*
 * Public API Surface of deepak-spinner-test
 */

export * from './lib/deepak-spinner-test.service';
export * from './lib/deepak-spinner-test.component';
export * from './lib/deepak-spinner-test.module';
export * from './lib/spinner/spinner.component';
